import React from "react";

const CARDS = [
  {
    icon: "bi-signpost-split-fill",
    title: "Operational Scope",
    text: "A SELECTEZI Marketing Agent provides promotional, visibility and connection support through SELECTEZI. The Marketing Agent does not automatically act as the user's legal representative, sales agent, broker, distributor, financial representative or contracting party.",
  },
  {
    icon: "bi-patch-check-fill",
    title: "Independent Outcomes",
    text: "The Marketing Agent does not guarantee sales, customers, profits, contracts, leads or business results.",
  },
  {
    icon: "bi-shield-check",
    title: "User Responsibility",
    text: "Users remain responsible for the accuracy of their business information, products, services, pricing, offers, negotiations, contracts and transactions.",
  },
];

export default function Governance() {
  return (
    <section className="section-py section-soft">
      <div className="container-selectezi">
        <div className="section-head">
          <span className="eyebrow-label">Governance Framework</span>
          <h2 className="section-title">Promotion &amp; Connection Support</h2>
          <p className="section-subtitle mx-auto">
            Clear roles and transparent boundaries designed to safeguard
            business autonomy and market integrity.
          </p>
        </div>

        <div className="governance-panel">
          <div className="row g-4">
            {CARDS.map((card) => (
              <div className="col-md-4" key={card.title}>
                <div className="governance-card">
                  <span className="icon-badge">
                    <i className={`bi ${card.icon}`} />
                  </span>
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="governance-cta">
            <p className="headline">
              SELECTEZI connects businesses with people and opportunities.
              Users decide. Users negotiate. Users transact.
            </p>
            <span className="caption">Autonomous Commercial Empowerment</span>
          </div>
        </div>
      </div>
    </section>
  );
}
